import classNames from "classnames";
import React from "react";
import IconLink from "../IconLink";
import { SearchIcon as SearchIconComponent } from "../icons";
import styles from "./SearchIcon.module.css";

export interface SearchIconProps {
  className?: string;
  "data-testid"?: string;
  onSearchClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const SearchIcon: React.FC<SearchIconProps> = ({
  className,
  "data-testid": dataTestId,
  onSearchClick,
}) => {
  const href = "";
  const label = "Search";
  const ariaLabel = "Search";

  return (
    <IconLink
      className={classNames(
        styles.searchIcon,
        className,
        "navi-header-fe-search-icon-cta",
      )}
      href={href}
      icon={<SearchIconComponent />}
      label={label}
      onClick={onSearchClick}
      data-testid={dataTestId || "header-search-icon-cta-test-id"}
      ariaLabel={ariaLabel}
    />
  );
};

export default SearchIcon;
